import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const fmt = (n) => String(n).replace(".", ",");

export default function ContractUeWarning({ clientId, totalUe, isAdmin, onFixed }) {
  const [chk, setChk] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/clients/${clientId}/contract-ue-check`).then((r) => setChk(r.data)).catch(() => setChk(null));
  }, [clientId, totalUe]);
  if (!chk?.differs) return null;
  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/clients/${clientId}/apply-contract-ue`);
      toast.success(`Gesamt-UE auf ${fmt(data.total_ue)} UE gesetzt`);
      onFixed();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="border border-amber-300 bg-amber-50 px-5 py-4 mb-6 flex items-center justify-between gap-4 flex-wrap" data-testid="contract-ue-warning">
      <div className="flex items-center gap-3">
        <AlertTriangle size={20} strokeWidth={1.5} className="text-amber-600 shrink-0" />
        <div>
          <div className="text-sm font-bold text-amber-900">UE weichen vom unterschriebenen Vertrag ab</div>
          <div className="text-xs text-amber-800" data-testid="contract-ue-warning-text">
            Akte: <b>{fmt(chk.total_ue)} UE</b> · Vertrag: <b>{fmt(chk.contract_ue)} UE</b>
          </div>
        </div>
      </div>
      {isAdmin && (
        <button onClick={apply} disabled={busy} data-testid="contract-ue-apply-btn"
          className="px-3 py-1.5 bg-slate-900 text-white text-[10px] font-bold uppercase tracking-overline hover:bg-black disabled:opacity-50">
          {busy ? "…" : "Auf Vertragswert setzen"}
        </button>
      )}
    </div>
  );
}
